/* ===========================================================
 * 
 *   Site Functionality
 * 
 *   This is the main JS functionalty for the site 
 * 
 *   Requires: jQuery
 * 
 * ===========================================================*/

jQuery(document).ready(function(){

    var formChecker = null;
    var formCheckerCount = 0;    

    formChecker = setInterval( function(){

        formCheckerCount++;

        if (formCheckerCount == 50) {
            clearInterval(formChecker);
            return;
        }

        jQuery( document ).trigger( 'gform_post_render' );
    }, 200);


});

$(function() {


    /**
     * Add the Insights menu
     */
    insightsMenu = $('.js__insights-menu').html();
    $('.menu-item-433').append('<ul class="sub-menu sub-menu-insights"><li>' + insightsMenu + '</li></ul>');
    
     /**
     * Homepage slideshow
     */

    var homeSlideInterval;
    var homeSlideCount;
    var homeSlideCurrent = 1;
    var homeSlidePaused = false;
    
    if ($('.page-banner-home-wrapper .page-banner').length > 0 ) {

        homeSlideCount = $('.page-banner-home-wrapper .page-banner').length;
        startTimer();
        
    }

    function startTimer() {

        window.clearInterval(homeSlideInterval);
        homeSlideInterval = window.setInterval(function(){
            
            if (homeSlidePaused) {
                return;
            }

            ++homeSlideCurrent;

            if (homeSlideCurrent > homeSlideCount) {
                homeSlideCurrent = 1 
            }
            toggleBanner( homeSlideCurrent );
        }, 6000);
    }



    $('.banner-control-item').on('click', function(e){
        
        e.preventDefault();
        e.stopPropagation();

        var showID = $(this).attr('data-relbannerid');

        if (showID) {
            homeSlideCurrent = showID;
            toggleBanner( showID );
            startTimer();
        }
    });

    $('.banner-control-item-pause').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();

        if (homeSlidePaused) {
            $('.banner-control-item-pause').removeClass('paused');
            $('.banner-control-item-pause').html('Pause Slideshow');
            homeSlidePaused = false;
        }

        else {
            $('.banner-control-item-pause').addClass('paused');
            $('.banner-control-item-pause').html('Resume Slideshow');
            homeSlidePaused = true;

        }
    })

    function toggleBanner( showID ) {

        var bannerToShow = $('[data-bannerid="' + showID + '"]');

        if (bannerToShow) {
            
            $('.page-banner-home-wrapper .page-banner.active').removeClass('active');
            bannerToShow.addClass('active');

            
            $('.banner-control-item').removeClass('active');
            $('[data-relbannerid="' + showID + '"]').addClass('active');
        }
    }

    /**
     * Toggle the search form 
     */
    $('.toggle-search, .close-search').on( 'click', function(){
        if ($('.searchform').hasClass('active')) {
            $('.searchform').removeClass('active');
            $('.search-results').empty();
            $('.searchform-input').val('');
        }

        else {

            windowWidth = $(window).width();

            if (windowWidth < 1025) {
                $('.searchform').css('width', 'auto');
            }

            else if (windowWidth < 1456) {
                $('.searchform').css('width', '106px');
                setTimeout( function(){
                    $('.searchform').animate({ 
                        width: '700px'
                    }, 200, function(){
                        $('.searchform-input').focus();
                        loadDefaultSearch();    
                    });
                }, 100 );
            }

            else {
                $('.searchform').css('width', '130px');
                setTimeout( function(){
                    $('.searchform').animate({ 
                        width: '1000px'
                    }, 200, function(){
                        $('.searchform-input').focus();
                        loadDefaultSearch();    
                    });
                }, 100 );
            }

            $('.searchform').addClass('active');
        }
    });
    
    var loadDefaultSearch = function(){
        $('#search-input').trigger('keyup');
    }
    
    $(window).on('resize', repositionSearch );

    function repositionSearch() {

        windowWidth = $(window).width();

        if (windowWidth < 1025) {
            $('.searchform').css('right', 0);
            $('.searchform').css('width', 'auto');
            $('.searchform input').attr('placeholder', 'Search');
        }

        else if (windowWidth < 1481) {
            $('.searchform').css('right', 0);
            $('.searchform').css('width', '800px');
            $('.searchform input').attr('placeholder', 'Search');
        }

        else {
            offset = (windowWidth - 1481) / 2;
            $('.searchform').css('right', offset);
            $('.searchform').css('width', '1000px');
            $('.searchform input').attr('placeholder', 'Search insights, services, and sitewide');
        }
    }

    repositionSearch();
    
     /**
     * Add aria labels
     */
    $('#site-navigation').attr('aria-label', 'Main');
    $('.page-search nav.pagination').attr('aria-label', 'Search Results Pagination');

   /**
     * Trigger the focus of a card when certain child elements are focused
     */
    $(document).on('focus','.js__triggerfocus', function(){
        $(this).closest('.card, .block-banner').addClass('focus');
    });

    $(document).on('blur','.js__triggerfocus', function(){
        $(this).closest('.card, .block-banner').removeClass('focus');
    });


    /**
     * Set an active class on form field focus
     */
    $(document).on('focus','.ginput_container > input, .ginput_container > select, .ginput_container > textarea', function(){
        $(this).closest('.gfield').addClass("active");
    }).on('blur','.ginput_container > input, .ginput_container > select, .ginput_container > textarea', function(){
        $(this).closest('.gfield').removeClass("active");
    });


    /**
     * Open the share links in new windows
     */
    $('a.share-link-trigger').on('click', function(e){

        if(e.handled === false) {
            return
        }

        e.preventDefault();

        //  Get the link attributes
        var $link   = $(this);
        var href    = $link.attr('href');
        var network = $link.attr('data-network');

        //  Different popup sizes
        var networks = {
            facebook : { width : 600, height : 300 },
            twitter  : { width : 600, height : 254 },
            linkedin : { width : 600, height : 473 }
        };

        //  Set the opener options
        var options = 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,';

        //  Open the share window
        window.open(href, '', options+'height='+networks[network].height+',width='+networks[network].width);

    });

    /**
     * Open the share email form
     */
    $('a.share-email-trigger').on('click', function(e){
        e.preventDefault();
        $('.share-widget-form', $(this).closest('.entry-meta-details-outer')).toggle();
    });

    /**
     * Close the share email form
     */
    $('.js__closeshare').on('click', function(e){
        e.preventDefault();
        $('.share-widget-form', $(this).closest('.entry-meta-details-outer')).hide();
    });

    /**
     * Remove some wordpress attributes
     */
    $('img.fullscreen').attr('width', '');
    $('img.fullscreen').attr('height', '');


    /**
     * Remove borders from copy links that contain images
     */
    $('a').filter(':has(img)').addClass('hasimage');


    /**
     * Add the fullscreen class to image parents
     */
    $('img.fullscreen').closest('p').addClass('has-fullscreen');


    /**
     * Scroll to the gated form
     */
    $(".entry-meta-access").on( 'click touchstart', function(e) {

        if(e.handled === false) {
            return
        }

        $('html, body').animate({
            scrollTop: $(".access-target").offset().top
        }, 500);
    });


    /**
     * Testimonial slideshow
     */
    $('.js__slick_testimonials').slick({
        dots: true,
        speed: 500,
        touchMove: true,
        centermode: true,
        adaptiveHeight: true,
        prevArrow: $('.slide-prev'),
        nextArrow: $('.slide-next'),
    });


    /**
     * Homepage Slideshow
     */

    // Callback to reposition the slideshow arrows
    // after the slide has changes, and on init
    function positionBlockSlideArrows() {

        if ($('.js__slick_home_slideshow').length <= 0 ) {
            return;
        }

        $('.home-casestudies-slides .slide-prev').show();
        $('.home-casestudies-slides .slide-next').show();
    }

    //  Hide the arrows when a slide change starts
    $('.js__slick_home_slideshow').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $('.home-casestudies-slides .slide-prev').hide();
        $('.home-casestudies-slides .slide-next').hide();
    });
    //  Set the init listener
    $('.js__slick_home_slideshow').on('init afterChange', positionBlockSlideArrows );
    
    //  Set a timer to make sure the arrows stay positioned
    var reShowTimer;
    $(window).on('resize', function(){
        $('.home-casestudies-slides .slide-prev').hide();
        $('.home-casestudies-slides .slide-next').hide();

        reShowTimer = setTimeout( positionBlockSlideArrows, 1000 );
    });

    setTimeout( positionBlockSlideArrows, 1000 );

    //  Start the slideshow
    $( '.js__slick_home_slideshow').each( function(){
        
       $(this).slick({
            dots: false,
            speed: 500,
            touchMove: true,
            centermode: true,
            adaptiveHeight: true,
            variableWidth: true,
            infinite: true,
            prevArrow: $('.slide-prev'),
            nextArrow: $('.slide-next'),
            centerMode: true,
            customPaging : function(slider, i) {
                return '<a href="javascript:void(0)">' + (i + 1) + '</a>';
            },
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });

    });
    
    
    /**
     * Make the cards clickable
     */
    $(document).on ('click', '[data-cardhref]', function( e ){
        _targetTag = $(e.target)[0].tagName;

        if (_targetTag == 'A') {
            return true;
        }

        $_card = $(this);   
        $_href = $_card.attr('data-cardhref');

        if (e.shiftKey || e.ctrlKey || e.metaKey) {
            window.open( $_href, '_blank');
        } else {
            window.location =  $_href;
        }
    });


    /**
     * Clean up some WYSIWYG editor markup
     */
    $('blockquote p').each( function() {
        $(this).closest('blockquote').html( $(this).html() );    
    });

    $(document).on('gform_post_render', function(event, form_id, current_page){
        $('.ginput_recaptcha').each( function() {
            $(this).closest('.gfield').addClass( 'has-captcha' );    
        })
    });

    
    /**
     * Scroll to the gated form
     */
    $(".entry-access").on('click touchstart', function(e) {

        if(e.handled === false) {
            return;
        }

        $('html, body').animate({
        scrollTop: ($(".access-target").offset().top - 100 )
        }, 500);
    });

    
    /**
     * Add key listeners to the cookiebar dismiss link
     */
    var triggerCookiebarDismiss = function( e ) {
        
        if(e.which == 13) {
            e.preventDefault();
            e.stopPropagation();
            $('#cookie_action_close_header').trigger('click');
        }

        if(e.which == 32) {
            e.preventDefault();
            e.stopPropagation();
            $('#cookie_action_close_header').trigger('click');
        }
    }

    $(document).on('keyup', '#cookie_action_close_header', triggerCookiebarDismiss );

    /**
     * Load the responsive background images whenever a form loads
     */
    $(document).on('gform_post_render', function(e) {
        responsiveBackgroundImages();
        // $('.footer-cta-letstalk-inner h3').contents().unwrap().wrap('<h2 class="gform_title" />');
        // $('.sidebar-item h3').contents().unwrap().wrap('<h2 class="gform_title" />');
    });

    /**
     * Load the responsive background images on load
     */
    responsiveBackgroundImages();

});